module.exports = __webpack_public_path__ + "static/media/gcdef_10063.e153f1b5.ico";